module.exports = "/wp-content/plugins/farmacy/assets/js/images/menu-vaping-icon-2-fdaa48d0f340dce38567ad5d2e53d9aa.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/elo-app/img/category_icons/menu-vaping-icon-2.svg
 ** module id = 1050
 ** module chunks = 1 76
 **/